
import React, { useState, useEffect } from 'react';
import { AreaStatus, Employee } from '../app/types';
import { GetAreaDTO } from '../models/AreaDTO';
import axios from 'axios';
import { urlEmpleados } from '../app/EndPoints';

interface EmployeeFormPageProps {
  employeeToEdit: Employee | null;
  onSave: (employee: { id?: number; name: string; role: string; enabled: number; }) => void;
  areas: GetAreaDTO[];
  idMembership:number;
  onCancel: () => void;
  onRefresh: () => void;
}

const EmployeeFormPage: React.FC<EmployeeFormPageProps> = ({ employeeToEdit, onSave, onCancel, onRefresh, areas, idMembership}) => {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');  
  const [error, setError] = useState('');
  const [isSubmited, setisSubmited] = useState(false);
  const [status, setStatus] = useState<AreaStatus>(employeeToEdit?.Enabled === 1 ? AreaStatus.ACTIVO : AreaStatus.INACTIVO);
  const activeAreas = areas.filter(a => a.Enabled === 1);

  useEffect(() => {
    if (employeeToEdit) {
      setName(employeeToEdit.Name);
      setRole(employeeToEdit.AreaName);      
      setRole(employeeToEdit.AreaName)
    } else {
      setName('');
      setRole('');     
    }
    setError('');
  }, [employeeToEdit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = name.trim();
    const trimmedRole = role.trim();

    if (!trimmedName || !trimmedRole) {
      setError('El nombre y el area son obligatorios.');
      return;
    }

    setisSubmited(true)
    let jsonData 
    if (employeeToEdit) {
      //EDITAR      
      jsonData = {
        "id" : employeeToEdit.Id,
        "name" : name.trim().toUpperCase(),
        "idarea" : role,
        "enabled" : status === AreaStatus.ACTIVO ? 1 : 0
      }      
      console.log(jsonData)
      await axios.patch(urlEmpleados, jsonData)
      .then((respuesta) => {                
        onRefresh()
        onCancel()
      })
      .catch((error) => {            
        setError(error)
        setisSubmited(false)
        console.log(error);
      });  
    }else{
      //CREAR
      jsonData = {
        "idmembership" : idMembership,
        "name" : name.trim().toUpperCase(),
        "idarea" : role
      }            
      await axios.post(urlEmpleados, jsonData)
        .then((respuesta) => {                      
          onRefresh()
          onCancel()
        })
        .catch((error) => {            
          setError(error)
          setisSubmited(false)
          console.log(error);
        });    
    }        
  };

  return (
    <div className="bg-surface dark:bg-dark-surface p-6 rounded-3xl shadow-sm max-w-2xl mx-auto">
      <div className="mb-6" style={{textAlign:"left"}}>
        <h2 className="text-2xl font-medium text-on-surface dark:text-dark-on-surface">
          {employeeToEdit ? 'Editar Empleado' : 'Crear Nuevo Empleado'}
        </h2>
        <p className="text-on-surface-variant dark:text-dark-on-surface-variant mt-1">
          Completa los detalles del empleado a continuación.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6" style={{textAlign:"left"}}>
        <div>
          <label htmlFor="employee-name" className="block text-sm font-medium text-on-surface-variant dark:text-dark-on-surface-variant mb-2">
            Nombre del Empleado
          </label>
          <input
            id="employee-name"
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError('');
            }}
            required
            className="w-full bg-surface-container dark:bg-dark-surface-container border-2 border-outline dark:border-dark-outline focus:border-primary dark:focus:border-dark-primary focus:ring-0 rounded-lg p-3 outline-none transition-colors"
            placeholder="Ej: Ana García"
          />
        </div>
        
        <div>
          <label htmlFor="employee-role" className="block text-sm font-medium text-on-surface-variant dark:text-dark-on-surface-variant mb-2">
            Área del Empleado
          </label>
          <select
            id="employee-role"
            value={role}
            onChange={(e) => {
                setRole(e.target.value);
                if (error) setError('0');
            }}
            required
            className="w-full bg-surface-container dark:bg-dark-surface-container border-2 border-outline dark:border-dark-outline focus:border-primary dark:focus:border-dark-primary focus:ring-0 rounded-lg p-3 outline-none transition-colors appearance-none"
          >
            <option value="" disabled>Selecciona un área</option>
            {activeAreas.map(area => (
                <option key={area.Id} value={area.Id}>
                    {area.Name}
                </option>
            ))}
          </select>
          {activeAreas.length === 0 && (
            <p className="text-xs text-on-surface-variant dark:text-dark-on-surface-variant mt-1">
                No hay áreas activas. Por favor, crea una en "Gestionar Áreas".
            </p>
          )}
        </div>    
        
        {employeeToEdit ? 
          <div>
            <label htmlFor="area-status" className="block text-sm font-medium text-on-surface-variant dark:text-dark-on-surface-variant mb-2">
              Estado
            </label>
            <select
              id="area-status"
              value={status}
              onChange={(e) => setStatus(e.target.value as AreaStatus)}
              className="w-full bg-surface-container dark:bg-dark-surface-container border-2 border-outline dark:border-dark-outline focus:border-primary dark:focus:border-dark-primary focus:ring-0 rounded-lg p-3 outline-none transition-colors appearance-none"
            >
              <option value={AreaStatus.ACTIVO}>Activo</option>
              <option value={AreaStatus.INACTIVO}>Inactivo</option>
            </select>
          </div> 
        :
          <></>
        }   

        {error && <p className="text-error dark:text-dark-error text-sm mt-2">{error}</p>}

        <div className="flex justify-end gap-4 pt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-6 py-2.5 rounded-full text-primary dark:text-dark-primary font-bold hover:bg-primary/10 dark:hover:bg-dark-primary/10 transition-colors"
          >
            Cancelar
          </button>
          <button           
            type="submit"
            className="px-6 py-2.5 rounded-full bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary font-bold hover:shadow-lg transition-shadow"
            disabled={isSubmited}
          >
            {employeeToEdit ? 'Guardar Cambios' : 'Crear Empleado'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmployeeFormPage;
